import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import styles from './ScheduleDateTimeDrawer.module.scss'
import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'
import dayjs, { Dayjs } from 'dayjs'
import { Heading } from 'blaze-ui/Heading/Heading'
import { NativeTimePicker } from 'blaze-ui/TimePicker/TimePicker'
import { Time } from '@internationalized/date'
import { TimeValue } from '@react-aria/datepicker'
import { useState } from 'react'
import { Button } from 'blaze-ui/Button'

interface ScheduleDateTimeDrawerProps extends DrawerProps {
  onDateSelect: (date: Date) => void
  selectedDate: Date
  hideTimePicker?: boolean
}

export const ScheduleDateTimeDrawer = ({
  onDateSelect,
  selectedDate,
  hideTimePicker = false,
  ...props
}: ScheduleDateTimeDrawerProps) => {
  const selectedDayjs = dayjs(selectedDate)
  const [selectedDateOnly, setSelectedDateOnly] = useState<Dayjs>(selectedDayjs)
  const [selectedTime, setSelectedTime] = useState<TimeValue>(new Time(selectedDayjs.hour(), selectedDayjs.minute()))

  const handleDateChange = (date: Dayjs | undefined) => {
    if (!date) return
    setSelectedDateOnly(date)
  }

  const handleTimeChange = (time: TimeValue) => {
    setSelectedTime(time)
  }

  const handleConfirm = () => {
    // Combine the selected date with the selected time
    const combinedDateTime = selectedDateOnly
      .hour(selectedTime.hour)
      .minute(selectedTime.minute)
      .second(0)
      .millisecond(0)

    onDateSelect(combinedDateTime.toDate())
  }

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>Change Date & Time</Heading>
              </Drawer.Title>
              <Drawer.Close label="Cancel" variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <div className={styles.body}>
                <DateTimePicker
                  inline
                  responsive
                  dateTime={selectedDateOnly}
                  setDateTime={handleDateChange}
                  showTimeControls={false}
                  allowPastDates
                />

                {!hideTimePicker && (
                  <div className={styles.timeSection}>
                    <div className={styles.timeSectionHeader}>Choose time of day to post at</div>
                    <div className={styles.timePickerContainer}>
                      <NativeTimePicker
                        value={selectedTime}
                        onChange={handleTimeChange}
                        showIcon={true}
                        showTimezone={true}
                        showChangeText={true}
                      />
                    </div>
                  </div>
                )}

                <div className={styles.confirmSection}>
                  <Button variant="primary" size="lg" fullWidth onPress={handleConfirm}>
                    Confirm
                  </Button>
                </div>
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
